import api from 'services/api'

export const fetchCarriers = () => api.get('/carriers')

export const fetchInternalCarriers = () => api.get('/carriers?internal=true')

export const fetchCarrier = id => api.get(`/carriers/${id}`)
